import { useDispatch, useSelector } from 'react-redux';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';

/**
 * useModal hook to handle common modal plumbing
 * @param type
 * @returns {{isOpen: boolean, clear: (function(): any)}}
 */
function useModal(type) {
  const dispatch = useDispatch();

  function clear() {
    dispatch(clearModal(type));
  }

  const { type: currentType, initialValue } =
    useSelector(({ modal }) => modal) || {};

  const isOpen = currentType ? currentType === type : false;

  return {
    clear,
    isOpen,
    initialValue
  };
}

export default useModal;
